// @flow
import NavbarContainer from './containers/NavbarContainer';

export default NavbarContainer;